export default "__VITE_ASSET__CXyedouC__"